import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserTableModel } from 'modules/Users/DataTableDef';

const initialState = {
  sortColumn: null as keyof UserTableModel | null,
  sortDirection: null as 'asc' | 'desc' | null,
  selection: [] as number[],
  filter: '',
  pageSize: 10,
  pageIndex: 0,
};

export type UsersTableState = Readonly<typeof initialState>;

export const slice = createSlice({
  name: 'usersTable',
  initialState,
  reducers: {
    setSortColumn: (state, action: PayloadAction<keyof UserTableModel | null>) => {
      state.sortColumn = action.payload;
    },
    setSortDirection: (state, action: PayloadAction<'asc' | 'desc' | null>) => {
      state.sortDirection = action.payload;
    },
    setSelection: (state, action: PayloadAction<number[]>) => {
      state.selection = action.payload;
    },
    setFilter: (state, action: PayloadAction<string>) => {
      state.filter = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    reset: state => {
      state.sortColumn = null;
      state.sortDirection = null;
      state.selection = [];
      state.filter = '';
      state.pageSize = 10;
    },
  },
});

export const {
  reset,
  setSortColumn,
  setSortDirection,
  setSelection,
  setFilter,
  setPageSize,
  setPageIndex,
} = slice.actions;

export default slice.reducer;
